<template>
  <div>
    <b-modal @hide="modalClose" ref="assignedRegistrationModal" :title="$t('担当工程登録')" size="xl">
      <b-container fluid>
        <div class="search inner">
          <h2 class="title">{{ $t("検索条件") }}</h2>
          <div class="content">
            <div class="d-flex flex-row">
              <div
                class="m-3 d-flex flex-row align-items-center justify-content-start form-group"
              >
                <label for="search-status" class="label">{{ $t("工場") }}:&nbsp;</label>
                <select class="custom-select select" id="id_factory" v-model="form.site">
                  <option selected></option>
                  <template
                    v-for="(item, index) in mixinSpacesListDisplay('site')"
                  >
                    <option :value="item.id" :key="`site-${index}`">{{ item.name }}</option>
                  </template>
                </select>
                <label for="search-status" class="label ml-3">{{ $t("部署") }}:&nbsp;</label>
                <select
                  name="factory"
                  class="input form-control"
                  id="id_department"
                  v-model="form.dep"
                >
                  <option value></option>
                  <template
                    v-for="(item, index) in mixinSpacesListDisplay('dep')"
                  >
                    <option :value="item.id" :key="`dep-${index}`">{{ item.name }}</option>
                  </template>
                </select>
              </div>
            </div>
          </div>
          <div class="button">
            <button class="btn btn-info" @click="searchProcesses()">{{ $t("検索") }}</button>
          </div>
        </div>
        <div class="table-list inner mt-4">
          <h2 class="title">{{ $t("検索結果") }}</h2>
          <div class="content">
            <table class="table table-bordered">
              <thead class="thead">
                <tr>
                  <th scope="col"></th>
                  <th scope="col">{{ $t("工場") }}</th>
                  <th scope="col">{{ $t("部署") }}</th>
                  <th scope="col">{{ $t("工程区分") }}</th>
                  <th scope="col">{{ $t("工程管理番号") }}</th>
                  <th scope="col">{{ $t("工程/設備名") }}</th>
                  <th scope="col">{{ $t("時間単価") }}</th>
                </tr>
              </thead>
              <tbody class="tbody">
                <template v-if="!load && mixinGetItems.length">
                  <tr v-for="(item, index) in mixinGetItems" :key="index">
                    <td><input v-model.number="create.form.processIds" type="checkbox" :value="item.id" /></td>
                    <td>{{ mixinSpacesDisplay(item.site) }}</td>
                    <td>{{ mixinSpacesDisplay(item.dep) }}</td>
                    <td>{{ $t(displayProcessKinds(item.processKindId)) }}</td>
                    <td>{{ item.code }}</td>
                    <td>{{ item.name }}</td>
                    <td class="text-right">{{ item.hourPrice | mixinNumberFormatDisplay}}</td>
                  </tr>
                </template>
                <template v-else-if="!load && !mixinGetItems.length">
                  <tr>
                    <td rowspan="2" colspan="99" class="text-center">
                      {{ $t("ノーデータメッセージ") }}
                    </td>
                  </tr>
                </template>
                <template v-else-if="load">
                  <tr>
                    <td colspan="12">
                      <div class="d-flex justify-content-center m-5" v-if="load">
                        <div class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <paginate
           v-model="mixinCurrentPage"
            :page-count="mixinGetPageCount"
            :force-page="mixinGetForcePage"
            :page-range="3"
            :margin-pages="1"
            :click-handler="mixinClickCallback"
            :prev-text="'«'"
            :next-text="'»'"
            :container-class="'pagination justify-content-end'"
            :page-class="'page-item'"
            :page-link-class="'page-link'"
            :prev-class="'page-item'"
            :prev-link-class="'page-link'"
            :next-class="'page-item'"
            :next-link-class="'page-link'"
            ref="page"
          ></paginate>
        </div>
      </b-container>
      <template v-slot:modal-footer>
        <p class="text-danger text-center" v-if="create.error">{{ create.error }}</p>
        <div class="d-flex justify-content-center align-items-center mt-4 mb-4 w-100">
          <button
            type="button"
            class="btn btn-success mr-3 d-flex align-items-center justify-content-center"
            @click="checkAffectedProcesses()"
            :disabled="create.editable"
          >
            <div
              class="d-flex justify-content-center align-items-center mr-3"
              v-if="create.editable"
            >
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </div>
            {{ $t("登録") }}
          </button>
          <button
            type="button"
            class="btn btn-light"
            @click="modalClose()"
            v-if="!create.confirm"
            :disabled="create.editable"
          >{{ $t("キャンセル") }}</button>
        </div>
      </template>
    </b-modal>

    <b-modal @hide="modalConfirmationClose" ref="unassignedConfirmation" :title="$t('担当工程設定変更')" size="l">
      <b-container fluid>
        <div class="inner mt-4">
          <div class="content" style="white-space: pre-line">
            {{$t('user.process.change.confirmation')}}
          </div>
        </div>
      </b-container>
      <template v-slot:modal-footer>
        <p class="text-danger text-center"></p>
        <div class="d-flex justify-content-center align-items-center mt-4 mb-4 w-100">
          <button
            type="button"
            class="btn btn-light"
            @click="modalConfirmationClose()"
          >{{ $t("キャンセル") }}</button>
          <button
            type="button"
            class="btn btn-success mr-3 d-flex align-items-center justify-content-center"
            @click="createRegister()"
          >{{ $t("OK") }}</button>
        </div>
      </template>
  </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      list: [],
      kindList: [],
      load: false,
      form: {
        site: null,
        dep: null,
      },
      create: {
        form: {
          id: '',
          cognitoUId: '',
          name: '',
          kana: '',
          code: '',
          loginId: '',
          workTime: '',
          sort: null,
          languageCode: this.$store.getters['auth/userdata'].languageCode,
          countryCode: this.$store.getters['auth/userdata'].countryCode,
          hourPrice: 0,
          site: null,
          dep: null,
          privilege: null,
          processIds: [],
          email: '',
          displayColor: '',
        },
        editable: false,
      },
      master: {},
      deleting: false,
    }
  },
  methods: {
    // モーダルを開いたときの処理
    async modalOpen(item) {

      const copy = this.mixin_deepcopy(item)
      if (copy.id) {
        if (copy.id) this.create.form.id = copy.id
        if (copy.cognitoUId) this.create.form.cognitoUId = copy.cognitoUId
        if (copy.name) this.create.form.name = copy.name
        if (copy.kana) this.create.form.kana = copy.kana
        if (copy.code) this.create.form.code = copy.code
        if (copy.workTime) this.create.form.workTime = copy.workTime
        if (copy.sort) this.create.form.sort = copy.sort
        if (copy.languageCode) this.create.form.languageCode = copy.languageCode
        if (copy.countryCode) this.create.form.countryCode = copy.countryCode
        if (copy.hourPrice) this.create.form.hourPrice = copy.hourPrice
        if (copy.site) this.create.form.site = copy.site
        if (copy.dep) this.create.form.dep = copy.dep
        if (copy.privilege) this.create.form.privilege = copy.privilege
        if (copy.email) this.create.form.email = copy.email
        if (copy.loginId) this.create.form.loginId = copy.loginId
        if (copy.processIds) this.create.form.processIds = copy.processIds.map(id => parseInt(id))
        if (copy.displayColor) this.create.form.displayColor = copy.displayColor
      }

      this.$refs.assignedRegistrationModal.show()
      await this.init()
    },
    async init() {
      this.load = true
      await this.getMasterData()
      await this.searchProcesses()
      await this.getProcesseKinds()
      this.load = false
    },
    async getMasterData() {
      try {
        this.master = []
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/masters`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          }
        )
        this.master = res.data
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    async searchProcesses() {
      let params = {}
      if (this.form.site) params.site = this.form.site
      if (this.form.dep) params.dep = this.form.dep
      params.limit = 600
      try {
        this.load = true
        this.list = []
        const res = await this.$axios.get(`${this.$appConfig.CommonApiUrl}/processes`, {
          headers: {
            'Authorization': this.authorization ? this.authorization : null,
          },
          params: params,
        })
        this.list = res.data
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
      this.load = false
    },
    async getProcesseKinds() {
      try {
        this.kindList = []
        const res = await this.$axios.get(`${this.$appConfig.CommonApiUrl}/process/kinds`, {
          headers: {
            'Authorization': this.authorization ? this.authorization : null,
          },
        })
        this.kindList = res.data
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    async checkAffectedProcesses() {
      this.create.editable = true
      let params = {}
      for (let key of Object.keys(this.create.form)) {
        if (this.create.form[key]) params[`${key}`] = this.mixin_deepcopy(this.create.form[key])
      }

      let method = 'put'
      try {
        let res = await this.$axios({
          method: method,
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          url: `${this.$appConfig.CommonApiUrl}/user/precheck-unassign-pic`,
          data: params,
        })

        if (!res.data['isAffected']) {
          this.createRegister()
          return
        }
      } catch (err) {
        console.log(err)
        this.$toasted.show(this.$t('データ登録エラーメッセージ'))
        return
      }
      this.$refs.unassignedConfirmation.show()
    },
    async createRegister() {
      this.modalConfirmationClose()
      this.create.editable = true
      // ToDo: 登録項目が合わないため、processIdsの登録を別APIにする
      let params = {}
      for (let key of Object.keys(this.create.form)) {
        if (this.create.form[key]) params[`${key}`] = this.mixin_deepcopy(this.create.form[key])
      }

      let method = 'put'
      try {
        await this.$axios({
          method: method,
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          url: `${this.$appConfig.CommonApiUrl}/user`,
          data: params,
        })

        this.$emit('registed')
        this.$toasted.success(this.$t('データ登録完了メッセージ'))
        this.$refs.assignedRegistrationModal.hide()
        this.create = {
          load: false,
          form: {
            id: '',
            cognitoUId: '',
            name: '',
            kana: '',
            code: '',
            loginId: '',
            workTime: '',
            languageCode: this.$store.getters['auth/userdata'].languageCode,
            countryCode: this.$store.getters['auth/userdata'].countryCode,
            hourPrice: 0,
            site: null,
            dep: null,
            privilege: null,
            processIds: [],
            email: '',
            displayColor: '',
          },
          editable: false,
          error: '',
        }
      } catch (err) {
        console.log(err)
        this.$toasted.show(this.$t('データ登録エラーメッセージ'))
      }
      this.create.editable = false
    },
    // モーダルを閉じるときの処理
    modalClose() {
      this.$refs.assignedRegistrationModal.hide()
    },
    modalConfirmationClose() {
      this.create.editable = false
      this.$refs.unassignedConfirmation.hide()
    },
    displayProcessKinds(id) {
      let displayName = ''
      const dataList = this.kindList.map(kind => kind.datas)
      dataList.forEach(datas =>
        datas.forEach(data => {
          if (data.id === id) {
            displayName = data.messageKey
          }
        })
      )
      return displayName
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>
